<div class="container-fluid mt-3">
  <h3>Qwen Commands</h3>

  <app-qwen-command-list [commands]="commands" (onDeleted)="loadCommands()"></app-qwen-command-list>
</div>
